import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IAnnotationsStore } from '../annotations.store';
import { AnnotationImageNameHeader } from '../components/AnnotationImageNameHeader';

export const AnnotationImageNameHeaderContainer = observer((): ReactElement => {
  const annotationsStore = useInjection(IAnnotationsStore.$);
  const { t } = useTranslator();

  const showWarning = annotationsStore.datasetStatus !== 'Published' && annotationsStore.datasetStatus !== 'PublishedUploading';

  return (
    <AnnotationImageNameHeader
      imageName={annotationsStore.imageName}
      datasetName={annotationsStore.datasetName}
      showWarning={showWarning}
      warningTooltip={t('unpublished')}
      isLoading={!annotationsStore.image}
    />
  );
});
